import { FidoSchoolSearchResponse, FidoUserSearchResponse, PassportSchoolPagination, SchoolPagination } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";

// ------ Load schools ------
export const loadDistrictSchools = createAction(
    "[Courses-Schools] Load District Schools",
    props<{
        districtID: number;
    }>()
);
export const loadTeacherSchools = createAction(
    "[Courses-Schools] Load Teacher Schools",
    props<{
        teacherID: number;
    }>()
);
export const loadTeacherSchoolsSuccess = createAction(
    "[Courses-Schools] Load Teacher Schools Success",
    props<{
        payload: PassportSchoolPagination;
    }>()
);

export const loadSchoolsFail = createAction(
    "[Courses-Schools] Load Schools Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadSchoolsSuccess = createAction(
    "[Courses-Schools] Load Schools Success",
    props<{
        payload: SchoolPagination;
    }>()
);

export const loadCoursesSchool = createAction(
    "[Courses-Schools] Load Fido School",
    props<{
        schoolID: string;
    }>()
);
export const loadCoursesSchoolFail = createAction(
    "[Courses-Schools] Load Fido School Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCoursesSchoolSuccess = createAction(
    "[Courses-Schools] Load Fido School Success",
    props<{
        payload: FidoSchoolSearchResponse;
    }>()
);

export const loadSchoolFidoStudents = createAction(
    "[Courses-Schools] Load School Fido Students",
    props<{
        schoolID: string;
        pagingparameter?: string;
    }>()
);
export const loadSchoolFidoStudentsNextBatch = createAction(
    "[Courses-Schools] Load School Fido Students Next Batch",
    props<{
        schoolID: string;
        pagingparameter?: string;
    }>()
);
export const loadSchoolFidoStudentsFail = createAction(
    "[Courses-Schools] Load School Fido Students Fail",
    props<{
        payload: any;
    }>()
);
export const loadSchoolFidoStudentsSuccess = createAction(
    "[Courses-Schools] Load School Fido Students Success",
    props<{
        res: FidoUserSearchResponse;
    }>()
);
